<ng-select *ngIf="isPublicProfile" [formControl]="serviceTypeControl" [items]="serviceTypes"
           [searchable]="false"
           bindLabel="value"
           bindValue="key"
           class="cursor-pointer"
           [notFoundText]="'notFound1' | translate"
           [placeholder]="'serviceType' | translate"
           style="margin-bottom: 15px">
</ng-select>
<ng-select *ngIf="doctor" [formControl]="specialityFormControl" [items]="doctor.specialties"
           [searchable]="false"
           bindLabel="specialtyName"
           bindValue="specialtyId"
           class="cursor-pointer"
           [notFoundText]="'nothing-found' | translate"
           placeholder="{{'specialty'|translate}}"
           style="margin-bottom: 15px"
           [class.disabled-ng-select-container]="isInsuranceBubble">
</ng-select>
<div *ngIf="doctor" class="service-type-switch">
  <button (click)="updateServiceType(2)" [disabled]="!doctor.visitAvailable"
          [ngClass]="{active: selectedServiceType === 2 && doctor.visitAvailable}"
          class="service-type__toggle"
          mat-flat-button>
    <mat-icon>home_outline</mat-icon>
    <span *ngIf="!isPublicProfile"> {{'visit' | translate}}</span>
  </button>
  <button (click)="updateServiceType(3)" [disabled]="!doctor.audioAvailable"
          [ngClass]="{active: selectedServiceType === 3 && doctor.audioAvailable}"
          class="service-type__toggle"
          mat-flat-button>
    <mat-icon>phone</mat-icon>
    <span *ngIf="!isPublicProfile"> {{'audio' | translate}}</span>
  </button>
  <button (click)="updateServiceType(1)" [disabled]="!doctor.videoAvailable"
          [ngClass]="{active: selectedServiceType === 1 && doctor.videoAvailable}"
          class="service-type__toggle"
          mat-flat-button>
    <mat-icon>videocam</mat-icon>
    <span *ngIf="!isPublicProfile"> {{'video' | translate}}</span>
  </button>
</div>
<div *ngIf="doctor && isPublicProfile && doctorSlotsAvailable" class="day-switcher">
  <button (click)="searchNextDate(false)" [disabled]="checkForBackwardDisable()" mat-icon-button>
    <mat-icon class="arrow">arrow_back</mat-icon>
  </button>
  <button (click)="searchNextDate(true)" [disabled]="checkForNextDisable()" mat-icon-button>
    <mat-icon class="arrow">arrow_forward</mat-icon>
  </button>
</div>
<div *ngIf="doctor && specialityFormControl.value && doctorSlotsAvailable" class="time-slot-wrapper">
  <div #timeTableWrapper class="time-table__wrapper form-row">
    <ng-container *ngFor="let date of doctor.timeSlotDTOs | keyvalue">
      <div [ngClass]="{'col-4': isPublicProfile, 'col-3': !isPublicProfile}" class="px-1">
        <div class="time-table-title position-relative">
          <div class="text-center">
            <span class="d-block">{{date.key | timezoneDate : 'ddd' : selectedLanguage }}</span>
            <span class="d-block font-weight-bold mr-1">{{date.key | timezoneDate : 'MMM, D' : selectedLanguage }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  <ng-container *ngIf="doctor">
    <ng-container *ngFor="let date of doctor.timeSlotDTOs | keyvalue">
      <div [ngClass]="{'col-4': isPublicProfile, 'col-3': !isPublicProfile}" class="px-1 slot-column">
        <div class="text-center time-table">
          <ng-container *ngFor="let timeSlot of date.value let i = index">
            <div (click)="startOrder(timeSlot)"
                 class="mb-1">
              <span *ngIf="i < allSlots">{{timeSlot.timeString}}</span>
            </div>
          </ng-container>
          <div class="row no-gutters">
            <div (click)="showMoreSlots()" class="col-12 more d-flex">
              <span *ngIf="!toggleSlots" class="w-100">{{'more' | translate}}</span>
              <span *ngIf="toggleSlots" class="w-100">{{'less' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  </div>
</div>

<ng-container *ngIf="doctor && specialityFormControl.value && !doctorSlotsAvailable">
  <div class="time-slot-wrapper form-row">
    <ng-container *ngFor="let i of [1,2,3,4]">
      <div class="px-1 slot-column col-3">
        <div class="text-center time-table">
          <div class="row no-gutters">
            <div class="col-12 flex-wrap">
              <ng-container *ngFor="let timeSlot of [1, 2]">
                <div (click)="startOrder(timeSlot)"
                     class="mb-1">
                  <span> - </span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <button (click)="requestDoctor($event)" *ngIf="doctor.canBeRequested" class="request-doctor"
          matRipple>
    {{'i-would-like-to-make-an-appointment-with-doctor' | translate}}
  </button>
  <span *ngIf="doctor.doctorRequested && !doctor.closestBackDate && !doctor.closestForwardDate"
        class="requested-doctor">
    <mat-icon>check</mat-icon>
      {{'your-wish-has-been-recorded' | translate}}
  </span>
  <span
    *ngIf="!doctor.closestBackDate && !doctor.closestForwardDate && doctor.message"
    class="requested-doctor-message">
    {{doctor.message}}
  </span>
  <button (click)="goToSelectedDate(doctor.closestForwardDate)" *ngIf="doctor.closestForwardDate"
          class="request-doctor next"
          matRipple>{{'nearest-avaliable-date' | translate}} {{doctor.closestForwardDate | date:'dd.MM.yyyy' : '' : selectedLanguage}}
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
  <div class="time-slot-wrapper form-row">
    <ng-container *ngFor="let i of [1,2,3,4]">
      <div class="px-1 slot-column col-3">
        <div class="text-center time-table">
          <div class="row no-gutters">
            <div class="col-12 flex-wrap">
              <ng-container *ngFor="let timeSlot of [1, 2]">
                <div class="mb-1">
                  <span> - </span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <button (click)="goToSelectedDate(doctor.closestBackDate)" *ngIf="doctor.closestBackDate"
          class="request-doctor next"
          matRipple>
    <mat-icon>keyboard_arrow_left</mat-icon>
    {{'nearest-avaliable-date' | translate}} {{doctor.closestBackDate | date:'dd.MM.yyyy' : '' : selectedLanguage}}
  </button>
</ng-container>

<!--</div>-->